import React from "react";
import { ViewMode } from "../data/navigation";
type BrandLabelProps = {
  view: ViewMode;
};

/** Renders "WHY i9 SPORTS" keeping the lowercase "i9" brand mark, or "ABOUT US". */
export function BrandLabel({
  view
}: BrandLabelProps) {
  if (view === "current") return <>About Us</>;
  return <>
      Why <span className="normal-case" data-id="element-1" data-mp="2eif7r55h6h1t">i9</span> Sports
    </>;
}